import { gql } from '@apollo/client'

export const edmCalculatorPendingPriceQuery = gql`
    query edmCalculatorPendingPriceQuery(
        $qmrId: UUID!
        $edmCalculatorInput: EdmCalculatorInput!
    ) {
        getPendingEdmCalculatorDomesticAndOverseasPrice(
            qmrId: $qmrId
            edmCalculatorInput: $edmCalculatorInput
        ) {
            stepItems {
                wire {
                    gear
                    roughness
                    cutPath
                    plateThickness
                }
                sinkerKnownRemoval {
                    roughness
                    setups
                    volumeRemoved
                }
                sinkerNoKnownRemoval {
                    roughness
                    setups
                    desiredFilletRadius
                    standardFilletRadius
                    lengthOfFillet
                }
                priceInCents {
                    usa
                    china
                    india
                }
            }
        }
    }
`
